import React, { useState, useEffect } from 'react';
import { ListBox } from 'primereact/listbox';
import { ScrollPanel } from 'primereact/scrollpanel';
import { useSelector, useDispatch } from 'react-redux';

import {
  fetchSlaJobs,
  fetchSlaList,
  setSlaJobDescription,
  setSlaJobMember,
} from './slaSlice';

export const SlaView = () => {
  const [selectedJobList, setSelectedJobList] = useState(null);
  const [selectedSlaList, setSelectedSlaList] = useState(null);
  const [selectedSlaMemberList, setSelectedSlaMemberList] = useState(null);
  const jobState = useSelector((state) => state.job);
  const slaState = useSelector((state) => state.sla);
  const {
    userId,
    clientId,
    slaJobList,
    slaJobDescription,
    slaListData,
    slaMembersList
  } = slaState;
  const {
    appLanguage,
  } = jobState;
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setSlaJobDescription(''));
    dispatch(setSlaJobMember([]));
    let param = {
      userId: userId,
      clientId: clientId,
    }
    dispatch(fetchSlaJobs(param));
    dispatch(fetchSlaList(param));
  }, [dispatch]);

  const getSlaJobDesription = (e) => {
    if (e?.value) {
      // dispatch(setSlaJobDescription(e?.value?.description));
      dispatch(setSlaJobDescription(e?.value?.description ? e?.value?.description : 'This job has no applied SLA. If you believe this to be incorrect, please contact your Xerox account manager.'));
    }
    setSelectedJobList(e.value);
  }

  const getSlaJobMember = (e) => {
    if (e?.value) {
      dispatch(setSlaJobMember(e?.value?.slaMemberList));
    }
    setSelectedSlaList(e.value);
  }


  return (
    <div className="sla-wrapper">
      <div className="two-col">
        <div className="left-col box-border">
          <div className="left-col-inner-left">
            <h3>{appLanguage["sla.label.joblist"]}</h3>
            <ScrollPanel style={{ width: "100%", height: "385px" }} className="">
              <ListBox
                filter
                value={selectedJobList}
                onChange={(e) => getSlaJobDesription(e)}
                options={slaJobList}
                optionLabel="joblist"
                className="w-full md:w-14rem"
                filterPlaceholder={appLanguage["preferences.label.placeholder.searchjob"]}
              />
            </ScrollPanel>
          </div>
          <div className="left-col-inner-right">
            <h3>{appLanguage["sla.label.sla"]}</h3>
            <p>{slaJobDescription}</p>
          </div>
        </div>
        <div className="right-col box-border">
          <div className="right-col-inner-left">
            <h3>{appLanguage["sla.label.slalist"]}</h3>
            <ScrollPanel
              style={{ width: "100%", height: "385px" }}
              className="custombar2">
              <ListBox
                filter
                value={selectedSlaList}
                onChange={(e) => getSlaJobMember(e)}
                options={slaListData}
                optionLabel="slalist"
                className="w-full md:w-14rem"
              />
            </ScrollPanel>
          </div>

          <div className="right-col-inner-right">
            <h3>{appLanguage["sla.label.sla-members"]}</h3>
            <ScrollPanel
              style={{ width: "100%", height: "385px" }}
              className="custombar2">
              <ListBox
                filter
                value={selectedSlaMemberList}
                onChange={(e) => setSelectedSlaMemberList(e.value)}
                options={slaMembersList}
                optionLabel="joblist"
                className="w-full md:w-14rem"
              />
            </ScrollPanel>
          </div>
        </div>
      </div>
      {/* <hr class="footer-border" /> */}
    </div>
  );
}
